import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Popup from 'reactjs-popup';
import { Button } from '@piplapps/pipl-ui';
import { BillingActions } from '../../../Redux/modules/billing/actions';
import { BillingSelectors } from '../../../Redux/modules/billing/selectors';
import { OrganizationActions } from '../../../Redux/modules/organization/actions';
import { OrganizationSelectors } from '../../../Redux/modules/organization/selectors';
import ApiService from '../../../Services/ApiService';
import AddCreditCard from './AddCreditCard';
import BillingInformation from './BillingInformation';
import styles from './BillingInformation.module.less';
import Invoices from './Invoices';
import RedirectModal from './RedirectModal';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';

const Billing = (props) => {
  const creditCardIsActive = props.data.is_active;
  const isManualBilling = props.data.manual_billing;
  const isInternal = props.data.internal;

  const getBillingInfo = () => {
    if (isManualBilling) {
      return (
        <div className={styles.message}>
          {gettext('You are set to')} <strong>{gettext('Manual Payment')}</strong>
        </div>
      );
    }

    if (isInternal && !creditCardIsActive) {
      return (
        <div className={styles.message}>
          {gettext('You are an')} <strong>{gettext('Internal User')}</strong>
        </div>
      );
    }

    return creditCardIsActive ? (
      <div>
        <BillingInformation data={props.data} />
      </div>
    ) : (
      <div className={styles.summaryLine}>{gettext('You have no credit card on file')}</div>
    );
  };

  const [showRedirectModal, toggleModal] = useState(false);

  const toggleRedirectModal = () => {
    toggleModal(!showRedirectModal);
  };

  const modalStyle = {
    width: '500px',
    boxShadow: 'rgba(101, 101, 101, 0.28) 0px 4px 12px 0px',
    border: 'none',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
  };
  return (
    <>
      <div className={styles.container}>
        <div className={styles.topHeader}>{gettext('Billing information')}</div>
        <div className={styles.header} id="page-title">
          {gettext('Payment')}
        </div>
        {props.isLoading && (
          <div className={styles.fields}>
            <div style={{ fontSize: 20, lineHeight: 1.5, width: 400 }}>
              <Skeleton count={3} />
              <div style={{ marginTop: 25 }}>
                <Skeleton count={1} height={30} width={200} />
              </div>
            </div>
          </div>
        )}
        {props.billingEditMode ? (
          <AddCreditCard data={props.data} toggleBillingEditMode={props.toggleBillingEditMode} />
        ) : (
          <div>
            {!props.isLoading && (
              <>
                {getBillingInfo()}
                <div className={styles.buttonAddWrapper}>
                  <AnalyticsHandler eventName={AnalyticsEventNames.CLICK_ADD_CREDIT_CARD}>
                    <Button
                      buttonClass="secondary-blue"
                      text={creditCardIsActive ? gettext('Change Credit Card') : gettext('Add Credit Card')}
                      onClick={
                        props.organizationDetails.address ? () => props.toggleBillingEditMode() : toggleRedirectModal
                      }
                      id="add-cc-button"
                    />
                  </AnalyticsHandler>
                  <Popup
                    open={showRedirectModal}
                    onClose={toggleModal}
                    modal
                    contentStyle={modalStyle}
                    closeOnDocumentClick={false}
                  >
                    <RedirectModal
                      close={() => toggleRedirectModal()}
                      redirect={() => {
                        props.setShouldGetRedirectedBack();
                        props.history.push(ApiService.generateLink('organization/'));
                      }}
                    />
                  </Popup>
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <div className={styles.sectionSeparator} />
      <Invoices
        invoices={props.invoices}
        paginationObject={props.paginationObject}
        fetchInvoices={props.fetchInvoices}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    isLoading: BillingSelectors.isLoadingBillingSelector(state),
    billingEditMode: BillingSelectors.billingEditModeSelector(state),
    organizationDetails: OrganizationSelectors.organizationDetailsSelector(state),
  };
};

const mapDispatchToProps = {
  toggleBillingEditMode: BillingActions.toggleBillingEditMode,
  setShouldGetRedirectedBack: OrganizationActions.redirectToCreditCard,
};

Billing.propTypes = {
  isLoading: PropTypes.bool,
  history: PropTypes.object,
  data: PropTypes.object,
  invoices: PropTypes.array,
  billingEditMode: PropTypes.bool,
  toggleBillingEditMode: PropTypes.func,
  paginationObject: PropTypes.object,
  organizationDetails: PropTypes.object,
  fetchInvoices: PropTypes.func,
  setShouldGetRedirectedBack: PropTypes.func,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Billing));
